import { Base } from './base';

export class entryNumber extends Base {
	protected data = [
    {
      id : -1,
      name: 'エラー',
    },
    {
      id : 1,
      name: 'TRUE',
    },
    {
      id : 0,
      name: 'FALSE',
    }
  ];

  public showJapanese(typeVal: number): string | Error {
    let result :any = this._throwErrorNotFound();
    
    this.data.map((value, index) => {
      if (value.id == typeVal) {
        result = value.name;
      }
    });

    return result;
  }
}


// WEBPACK FOOTER //
// ./src/app/services/Enums/entryValue.ts